const TabsVideoBox = () => {
	const block = document.querySelectorAll(".tabs-video-box");
	if (!block) {
		return;
	}

	block.forEach((el) => {
		const tabsButtons = el.querySelectorAll(".tabs-video-box__nav-control");
		const videos = el.querySelectorAll(".tabs-video-box__video-el");
		const navSelect = el.querySelector(".tabs-video-box__nav-select select");

		const choices = new Choices(navSelect, {
			allowHTML: true,
			searchEnabled: false,
			itemSelectText: "",
			shouldSort: false
		});

		navSelect.addEventListener("change", (e) => {
			const target = el.querySelector(`${e.target.options[e.target.selectedIndex].value}`);

			pauseVideos();
			el.querySelector(`[data-toggle-target='${e.target.options[e.target.selectedIndex].value}']`).dispatchEvent(new Event('click'));
			target.querySelector(".tabs-video-box__video-el").play();
		});

		const pauseVideos = () => {
			videos.forEach(v => {
				v.pause();
			});
		};

		tabsButtons.forEach(button => {
			button.addEventListener("click", (e) => {
				const target = el.querySelector(`${e.target.getAttribute("data-toggle-target")}`);
				
				pauseVideos();
				target.querySelector(".tabs-video-box__video-el").play();
			});
		});
	});
};

export default TabsVideoBox;
